module.exports = __webpack_public_path__ + "img/photo-coming.f28acef1.jpg";